import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  updateScreenAction,
  addScreenAction,
  backScreenAction,
} from "../actions";
import gardenUseIcon from "../images/garden-use.jpg";
import Wrapper from "../components/Wrapper";
import Option from "../components/Option";
import Button from "../components/Button";
import { INTENDED_APP, QUESTION4, WATER_SOURCE, SHOW_MORE } from "../constants";

function Question3({ dispatch, screens, addScreen, backScreen, updateScreen }) {
  const isTankWater = screens.answers.WATER_SOURCE === "tank_water";

  const [gardenUse, setGardenUse] = useState(false);
  const [houseGardenUse, setHouseGardenUse] = useState(false);

  const getAnswer = () => {
    if (isTankWater) {
      return "tank_water";
    } else {
      return "mains_and_tank";
    }
  };
  const getValue = () => {
    if (gardenUse) {
      return "garden";
    } else {
      return "house_and_garden";
    }
  };

  useEffect(() => {
    if (screens.answers.INTENDED_APP) {
      if (screens.answers.INTENDED_APP === "garden") {
        setGardenUse(true);
      }
      if (screens.answers.INTENDED_APP === "house_and_garden") {
        setHouseGardenUse(true);
      }
    }
  }, [screens.answers.INTENDED_APP]);
  const isBtnDisabled = !gardenUse && !houseGardenUse;
  return (
    <Wrapper stepNo={"3"} question={"3. What is the intended application?"}>
      <div
        className="uk-child-width-expand@s uk-grid-match uk-text-center c-quiz_options"
        uk-grid="margin: uk-margin-small uk-margin@s"
      >
        <div className="c-quiz_options--option">
          <div
            className={`uk-card uk-card-default uk-card-body c-quiz_options--option-body  ${
              gardenUse ? "c-quiz_options--option-selected" : ""
            }`}
            onClick={() => {
              setGardenUse(true);
              setHouseGardenUse(false);
            }}
          >
            <img
              src={gardenUseIcon}
              alt="Electricity icon"
              className="c-quiz_icon icon-sm"
            />
            <h3>Garden Use</h3>
            <p>Refers to domestic garden use.</p>
          </div>
        </div>

        <Option
          name="House & Garden Use"
          description="Refers to domestic toilet(s), laundry, and garden use."
          iconName="house-garden-use"
          optionClassName={`${
            houseGardenUse ? "c-quiz_options--option-selected" : ""
          }`}
          onClick={() => {
            setGardenUse(false);
            setHouseGardenUse(true);
          }}
        />
      </div>
      <Button
        text={"Back"}
        secondary
        onClick={() => {
          backScreen({
            back_screen: WATER_SOURCE,
          });
        }}
      />

      <Button
        text={"continue"}
        disabled={isBtnDisabled}
        onClick={() => {
          const answer = getAnswer();
          const value = getValue();
          if (answer === "tank_water" && value === "house_and_garden") {
            updateScreen({
              curr_screen: INTENDED_APP,
              next_screen: SHOW_MORE,
              answer: answer,
            });
          } else {
            updateScreen({
              curr_screen: INTENDED_APP,
              next_screen: QUESTION4,
              answer: value,
            });
          }
        }}
      />
    </Wrapper>
  );
}

const mapStateToProps = (state) => ({
  screens: state.questions,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateScreen: updateScreenAction,
      addScreen: addScreenAction,
      backScreen: backScreenAction,
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(Question3);
